var routes = require('./routes.json');

export default function route() {
	var args = Array.prototype.slice.call(arguments);
	var name = args.shift();

	if (routes[name] === undefined) {
		console.error('Unknown route ', name);
	} else {
		let route = '/' + routes[name].split('/').map(s => s[0] == '{' ? args.shift() : s).join('/');
		if (route.indexOf('//') == 0) {
			return route.substr(1);
		} else {
			return route;
		}
	}
}


// WEBPACK FOOTER //
// ./resources/assets/js/route.js